import auth from '../../../api/auth'


export default {

  Now_yyyy_MM_dd() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  },

  Date_yyyy_MM_dd(val) {
    var today = new Date(val);
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  },

  http_post(owner, url, prm) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/Coper/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.CariBilgi.SirketKodu.toString(),
        'CoperSirketNo': credentials.CariBilgi.CoperSirketNo.toString(),
      }
    })
  },

  api_post(owner, url, prm) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.CariBilgi.SirketKodu.toString(),
        'CoperSirketNo': credentials.CariBilgi.CoperSirketNo.toString(),

      }
    })
  },
  
  // api_post_FileDownload(owner, url, prm) {
  //   return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
  //     headers: {
  //       'Authorization': 'Bearer ' + auth.getAuthHeader(),
  //     },responseType: "arraybuffer"
  //   })
  // },

  api_post_FileDownload(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.CariBilgi.SirketKodu.toString(),
        'CoperSirketNo': credentials.CariBilgi.CoperSirketNo.toString(),
        'MuhasebeSirketNo': 0,
      },responseType: "arraybuffer"
    })
  },


  api_file_post(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CoperSirketNo': credentials.CariBilgi.CoperSirketNo.toString(),
        'CariSirketNo': credentials.CariBilgi.SirketKodu.toString(),
        'Content-Type': 'multipart/form-data'

      }
    })
  },
  

 
  responseToStatus(response) {
    var status = this.NewSatatus();
    if (response.status === 0) {
      status.text = 'Wep servis hizmet dışı. Lütfen daha sonra tekrar deneyin.'
      status.show = true;
      status.loading = false;
    } else {
      status.text = response.statusText
      status.show = true;
      status.loading = false;
    }
    return status
  },

  NewSatatus() {
    return {
      show: false,
      text: "",
      loading: false,
    }
  }





}